var RoomTypePriceBuilderErrors = {
	
  general: function (errors) {
    var err = [];

    if (errors.base && errors.base.length) {
      for (var i = 0, ilen = errors.base.length; i < ilen; i++) {
        err.push(errors.base[i]);
      }
    }

    // *** Start Date *** //

    if (errors.start_date && errors.start_date.length) {
      for (var i = 0, ilen = errors.start_date.length; i < ilen; i++) {
        err.push(I18n.t('start_date') + ' ' + errors.start_date[i]);
      }
    }

    // *** Min Stay *** //

    if (errors.monday_minimum_stay && errors.monday_minimum_stay.length) {
      for (var i = 0, ilen = errors.monday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('monday_minimum_stay') + ' ' + errors.monday_minimum_stay[i]);
      }
    }

    if (errors.tuesday_minimum_stay && errors.tuesday_minimum_stay.length) {
      for (var i = 0, ilen = errors.tuesday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('tuesday_minimum_stay') + ' ' + errors.tuesday_minimum_stay[i]);
      }
    }

    if (errors.wednesday_minimum_stay && errors.wednesday_minimum_stay.length) {
      for (var i = 0, ilen = errors.wednesday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('wednesday_minimum_stay') + ' ' + errors.wednesday_minimum_stay[i]);
      }
    }

    if (errors.thursday_minimum_stay && errors.thursday_minimum_stay.length) {
      for (var i = 0, ilen = errors.thursday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('thursday_minimum_stay') + ' ' + errors.thursday_minimum_stay[i]);
      }
    }

    if (errors.friday_minimum_stay && errors.friday_minimum_stay.length) {
      for (var i = 0, ilen = errors.friday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('friday_minimum_stay') + ' ' + errors.friday_minimum_stay[i]);
      }
    }

    if (errors.saturday_minimum_stay && errors.saturday_minimum_stay.length) {
      for (var i = 0, ilen = errors.saturday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('saturday_minimum_stay') + ' ' + errors.saturday_minimum_stay[i]);
      }
    }

    if (errors.sunday_minimum_stay && errors.sunday_minimum_stay.length) {
      for (var i = 0, ilen = errors.sunday_minimum_stay.length; i < ilen; i++) {
        err.push(I18n.t('sunday_minimum_stay') + ' ' + errors.sunday_minimum_stay[i]);
      }
    }
    
    // ***  Price *** //

    if (errors.monday_amount && errors.monday_amount.length) {
      for (var i = 0, ilen = errors.monday_amount.length; i < ilen; i++) {
        err.push(I18n.t('monday_amount') + ' ' + errors.monday_amount[i]);
      }
    }

    if (errors.tuesday_amount && errors.tuesday_amount.length) {
      for (var i = 0, ilen = errors.tuesday_amount.length; i < ilen; i++) {
        err.push(I18n.t('tuesday_amount') + ' ' + errors.tuesday_amount[i]);
      }
    }

    if (errors.wednesday_amount && errors.wednesday_amount.length) {
      for (var i = 0, ilen = errors.wednesday_amount.length; i < ilen; i++) {
        err.push(I18n.t('wednesday_amount') + ' ' + errors.wednesday_amount[i]);
      }
    }

    if (errors.thursday_amount && errors.thursday_amount.length) {
      for (var i = 0, ilen = errors.thursday_amount.length; i < ilen; i++) {
        err.push(I18n.t('thursday_amount') + ' ' + errors.thursday_amount[i]);
      }
    }

    if (errors.friday_amount && errors.friday_amount.length) {
      for (var i = 0, ilen = errors.friday_amount.length; i < ilen; i++) {
        err.push(I18n.t('friday_amount') + ' ' + errors.friday_amount[i]);
      }
    }

    if (errors.saturday_amount && errors.saturday_amount.length) {
      for (var i = 0, ilen = errors.saturday_amount.length; i < ilen; i++) {
        err.push(I18n.t('saturday_amount') + ' ' + errors.saturday_amount[i]);
      }
    }

    if (errors.sunday_amount && errors.sunday_amount.length) {
      for (var i = 0, ilen = errors.sunday_amount.length; i < ilen; i++) {
        err.push(I18n.t('sunday_amount') + ' ' + errors.sunday_amount[i]);
      }
    }

    return err;
  },

  seasonal_pricing: function (errors) {
    var err = [];

    /**
    * Seasonal Pricing doesn't currently need validation.
    * If it needs it in the future, it can be added/handled here.
    */

    return err;    
  },

}

export default RoomTypePriceBuilderErrors